import React, { useEffect, useState } from 'react'

import { Button, DatePicker, message, Popconfirm } from 'antd'

import { getApiTargetInfo } from 'core'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
  getEnvConfig,
} from 'core/selectors'

import { Label } from 'core/screen-util'
import { SppAcaAnplhHeaders } from './ACAHeaders'
import { deletenplh, getnplh, postnplh } from './acaapi'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import moment from 'moment'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

const ACAnplh = ({ permitActions }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '100px 300px 150px 100px 150px',
          gap: 5,
        }}
      >
        <Label>ANPLH :</Label>
        <DatePicker
          style={{ minWidth: '120px' }}
          onChange={date =>
            setInsertData({
              ...insertData,
              anplh: date
                .minute(0)
                .second(0)
                .format('YYYY-MM-DDTHH:mm:ss'),
              anplh2: date,
              // transDate: date,
            })
          }
          value={insertData.anplh2}
          placeholder="ANPLH"
          format="MM/DD/YYYY HH"
          allowClear={false}
          showTime={{ format: 'HH' }}
        />

        <div style={{ gridColumnEnd: 'span 3' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>

          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginLeft: '20px' }}
          >
            Add & Hide
          </Button>
          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }
  const [monthSelection, setMonthSelection] = useState(
    moment().startOf('month')
  )

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.MonthPicker
        allowClear={false}
        format="MMMM-YYYY"
        value={monthSelection}
        onChange={d => {
          setMonthSelection(d.startOf('month'))
          onChange({})
        }}
      />
    )
  }
  const withCriteria = () => ({
    startDate: monthSelection
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD'),
    endDate: monthSelection
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD'),
  })

  const extraCriteriaAfterButton = ({
    onRetrieve,
    isEditableAllowed,
    setSpinning,
    loading,
    data,
    apiTargetInfo,
    setError,
  }) => {
    if (!isEditableAllowed) return <div />
    return (
      <Popconfirm
        title="This action will delete all retrieved data. Do you want to continue?"
        okText="Yes"
        cancelText="No"
        onConfirm={() => {
          setSpinning(true)
          deletenplh(apiTargetInfo)(data).fork(setError, _ => {
            setSpinning(false)
            message.success('Data removed successfully')
            onRetrieve()
          })
        }}
        // disabled={selected.selectedRows && selected.selectedRows.length <= 0}
        placement="topRight"
        // disabled
      >
        <Button
          loading={loading}
          icon="delete"
          style={{
            marginLeft: '10px',
            // color: '#FFFFFF',
            // backgroundColor: '#FF0000',
          }}
          type="danger"
          disabled={data.length <= 0}
        >
          Remove ALL
        </Button>
      </Popconfirm>
    )
  }

  const [withoutModify, setWithoutModify] = useState(true)
  useEffect(() => {
    const isAdmin = hasAccesPermits({
      actionPermits: permitActions,
      eventActions: [ScreenPermissions.AEP_ACA_SPP_DATA_WRITE],
      matchAny: true,
    })
    setWithoutModify(!isAdmin)
  }, [permitActions])

  return (
    <CommonScreen
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      screenCriteria={screenCriteria}
      withCriteria={withCriteria}
      title="SPP Adjusted Net Peak Load Hours (ANPLH)"
      titleProps={{ width: 450 }}
      header={SppAcaAnplhHeaders}
      initialSortOptions={SppAcaAnplhHeaders}
      saveTask={postnplh}
      retrieveTask={getnplh}
      deleteTask={deletenplh}
      altBy={d => d.anplh}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      withImport
      importUrl="screen-csv-import-file"
      importData={{ importType: 'ACAP_ANPLH' }}
      importSucessRetrieve
      isAdminScreen={false}
      withoutModify={withoutModify}
      allowInsert={!withoutModify}
      // widthOffset={550}

      // widthOffset={550}
      // heightOffset={100}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  permitActions: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(ACAnplh)
